import {ResourceParams} from "../resources";

export type TeamReportResourceType =
  'day-reports' |
  'week-reports' |
  'month-reports' |
  'plan-fact-reports' |
  'pulse-reports' |
  'release-calendar' |
  'mistakes' |
  'article-day-reports' |
  'article-week-reports' |
  'article-month-reports' |
  'price-level-configs' |
  'price-levels';

export const teamReportResources: {
  [key in TeamReportResourceType]: ResourceParams
} = {
  'article-day-reports': {
    key: 'article-day-reports',
    name: 'Ежедневный отчет (артикулы)',
    path: 'article-day-reports'
  },
  'article-week-reports': {
    key: 'article-week-reports',
    name: 'Еженедельный отчет (артикулы)',
    path: 'article-week-reports'
  },
  'article-month-reports': {
    key: 'article-month-reports',
    name: 'Ежемесячный отчет (артикулы)',
    path: 'article-month-reports'
  },
  'day-reports': {
    key: 'day-reports',
    name: 'Ежедневный по категориям',
    path: 'day-reports'
  },
  'week-reports': {
    key: 'week-reports',
    name: 'Недельный по категориям',
    path: 'week-reports'
  },
  'month-reports': {
    key: 'month-reports',
    name: 'Месячный по категориям',
    path: 'month-reports'
  },
  'plan-fact-reports': {
    key: 'plan-fact',
    name: 'План/факт отчет',
    path: 'plan-fact'
  },
  'pulse-reports': {
    key: 'pulse-reports',
    name: 'Рука на пульсе',
    path: 'pulse-reports'
  },
  'release-calendar': {
    key: 'release-calendar',
    name: 'Календарь выходов',
    path: 'release-calendar'
  },
  'mistakes': {
    key: 'mistakes',
    name: 'Ошибки',
    path: 'mistakes'
  },
  'price-level-configs': {
    key: 'price-level-configs',
    name: 'Настройка уровней цен',
    path: 'price-level-configs'
  },
  'price-levels': {
    key: 'price-levels',
    name: 'Уровни цены',
    path: 'price-levels'
  }
};
